module.exports = {
      id: "hamburger-spotify-usage",
      viewBox: "0 0 36 37",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#hamburger-spotify",
      toString: function () {
        return this.url;
      }
    }